module.exports = __webpack_public_path__ + "media/images/landscape-background-fbcd507d82f257cd10885022f0f2f97b.png";